/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsPackingLineVo } from './GoodsPackingLineVo';
import {
    GoodsPackingLineVoFromJSON,
    GoodsPackingLineVoFromJSONTyped,
    GoodsPackingLineVoToJSON,
    GoodsPackingLineVoToJSONTyped,
} from './GoodsPackingLineVo';
import type { PalletInnerBoxVo } from './PalletInnerBoxVo';
import {
    PalletInnerBoxVoFromJSON,
    PalletInnerBoxVoFromJSONTyped,
    PalletInnerBoxVoToJSON,
    PalletInnerBoxVoToJSONTyped,
} from './PalletInnerBoxVo';

/**
 * 
 * @export
 * @interface PalletGroupVo
 */
export interface PalletGroupVo {
    /**
     * 托盘 id
     * @type {number}
     * @memberof PalletGroupVo
     */
    palletId?: number;
    /**
     * 托盘唛头号 markNo
     * @type {string}
     * @memberof PalletGroupVo
     */
    markNo?: string;
    /**
     * 托盘重量 kg
     * @type {number}
     * @memberof PalletGroupVo
     */
    wtKg?: number;
    /**
     * 托盘 CBM
     * @type {number}
     * @memberof PalletGroupVo
     */
    cbm?: number;
    /**
     * 托盘长 cm
     * @type {number}
     * @memberof PalletGroupVo
     */
    length?: number;
    /**
     * 托盘宽 cm
     * @type {number}
     * @memberof PalletGroupVo
     */
    width?: number;
    /**
     * 托盘高 cm
     * @type {number}
     * @memberof PalletGroupVo
     */
    height?: number;
    /**
     * 托盘内箱子列表
     * @type {Array<PalletInnerBoxVo>}
     * @memberof PalletGroupVo
     */
    boxes?: Array<PalletInnerBoxVo>;
    /**
     * 散货上托商品行（containsType=商品，结构与箱内 lines 一致；boxQuantity 为本托该合包数量）
     * @type {Array<GoodsPackingLineVo>}
     * @memberof PalletGroupVo
     */
    lines?: Array<GoodsPackingLineVo>;
}

/**
 * Check if a given object implements the PalletGroupVo interface.
 */
export function instanceOfPalletGroupVo(value: object): value is PalletGroupVo {
    return true;
}

export function PalletGroupVoFromJSON(json: any): PalletGroupVo {
    return PalletGroupVoFromJSONTyped(json, false);
}

export function PalletGroupVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalletGroupVo {
    if (json == null) {
        return json;
    }
    return {
        
        'palletId': json['palletId'] == null ? undefined : json['palletId'],
        'markNo': json['markNo'] == null ? undefined : json['markNo'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'boxes': json['boxes'] == null ? undefined : ((json['boxes'] as Array<any>).map(PalletInnerBoxVoFromJSON)),
        'lines': json['lines'] == null ? undefined : ((json['lines'] as Array<any>).map(GoodsPackingLineVoFromJSON)),
    };
}

export function PalletGroupVoToJSON(json: any): PalletGroupVo {
    return PalletGroupVoToJSONTyped(json, false);
}

export function PalletGroupVoToJSONTyped(value?: PalletGroupVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'palletId': value['palletId'],
        'markNo': value['markNo'],
        'wtKg': value['wtKg'],
        'cbm': value['cbm'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'boxes': value['boxes'] == null ? undefined : ((value['boxes'] as Array<any>).map(PalletInnerBoxVoToJSON)),
        'lines': value['lines'] == null ? undefined : ((value['lines'] as Array<any>).map(GoodsPackingLineVoToJSON)),
    };
}

